import React from 'react'

const MasterHeader = (props) => {

    return (
        <header className="masthead" style={{ backgroundImage: `url(${props.master.background})`, minHeight: '448px' }}>
            <div className="container">
                <div className="intro-text">
                    <div className="intro-lead-in">{props.master.title}</div>
                    <div className="intro-heading">{props.master.subtitle}</div>
                    {props.master.content &&
                        <div className="intro-content">{props.master.content}</div>
                    }
                    {
                        props.master.items.map((e, k) => (
                            <a key={k} className="btn btn-primary js-scroll-trigger" style={{ marginRight: '10px' }} href={"#" + e.ref}>{e.item}</a>
                        ))}
                    {props.children}
                </div>
            </div>
        </header>
    );
}

export default MasterHeader;